mapboxgl.accessToken = 'pk.eyJ1Ijoib2xzZW5ldXJvcGUiLCJhIjoiY2xjamRncHB3MDY5cDN2cW9rYjNjNTM2ZiJ9.VGL4lPNqnuzFv_zJ9RSgqg';

const stores = {
  type: 'FeatureCollection',
  features: [
   //  {
 //  type: 'Feature',
 //  geometry: { type: 'Point', coordinates: [-75.8094394,45.347381] },
 //  properties: {
 //    phoneFormatted: '+1(905) 954-4138',
 //    name: '<span style="font-weight:bold;color:#FFFFFF;background:#000000;padding:2px 5px;font-size:12px;">NEW!</span> Upper Canada Mall',
 //    phone: '(905) 954-4138',
 //    address: '17600 Yonge St, unit: D26',
 //    city: 'Newmarket',
 //    state: 'ON',
 //    postalCode: 'L3Y 4Z1',
 //    country: 'Canada',
 //    hours: {
 //      monday: '10:00 AM - 9:00 PM',
 //      tuesday: '10:00 AM - 9:00 PM',
  //     wednesday: '10:00 AM - 9:00 PM',
  //     thursday: '10:00 AM - 9:00 PM',
 //      friday: '10:00 AM - 9:00 PM',
  //     saturday: '10:00 AM - 8:00 PM',
  //     sunday: '11:00 AM - 7:00 PM'
 //    }
 //  }
// },
       {
  type: 'Feature',
  geometry: { type: 'Point', coordinates: [-75.8094394,45.347381] },
  properties: {
    phoneFormatted: '(613) 740-9851',
    name: '<span style="font-weight:bold;color:#FFFFFF;background:#000000;padding:2px 5px;font-size:12px;">NEW!</span> Bayshore Shopping Centre',
    phone: '(613) 740-9851',
    address: '100 Bayshore Dr, Unit T10',
    city: 'Ottawa',
    state: 'ON',
    postalCode: 'K2B 8C1',
    country: 'Canada',
    hours: {
      monday: '9:00 AM - 9:00 PM',
      tuesday: '9:00 AM - 9:00 PM',
      wednesday: '9:00 AM - 9:00 PM',
      thursday: '9:00 AM - 9:00 PM',
      friday: '9:00 AM - 9:00 PM',
      saturday: '9:00 AM - 9:00 PM',
      sunday: '10:00 AM - 6:00 PM'
    }
  }
},
     {
  type: 'Feature',
  geometry: { type: 'Point', coordinates: [-123.1384481,49.1672705] },
  properties: {
    phoneFormatted: '(604) 288-6443',
    name: 'CF Richmond Centre',
    phone: '(604) 288-6443',
    address: '6551 Number 3 Rd, unit 1537',
    city: 'Richmond',
    state: 'BC',
    postalCode: 'V6Y 2B6',
    country: 'Canada',
    hours: {
      monday: '10:00 AM - 9:00 PM',
      tuesday: '10:00 AM - 9:00 PM',
      wednesday: '10:00 AM - 9:00 PM',
      thursday: '10:00 AM - 9:00 PM',
      friday: '10:00 AM - 9:00 PM',
      saturday: '10:00 AM - 9:00 PM',
      sunday: '11:00 AM - 7:00 PM'
    }
  }
},
{
  type: 'Feature',
  geometry: { type: 'Point', coordinates: [-79.2827, 43.8687] },
  properties: {
    phoneFormatted: '(905) 201-5272',
    name: 'CF Markville',
    phone: '(905) 201-5272',
    address: '5000 Hwy 7',
    city: 'Markham',
    state: 'ON',
    postalCode: 'L3R 4M9',
    country: 'Canada',
    hours: {
      monday: '10:00 AM - 9:00 PM',
      tuesday: '10:00 AM - 9:00 PM',
      wednesday: '10:00 AM - 9:00 PM',
      thursday: '10:00 AM - 9:00 PM',
      friday: '10:00 AM - 9:00 PM',
      saturday: '10:00 AM - 6:00 PM',
      sunday: '11:00 AM - 6:00 PM'
    }
  }
},
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-79.5715232, 43.5930256] },
      properties: {
        phoneFormatted: '(905) 891-4227',
        name: 'Dixie Outlet Mall',
        phone: '(905) 891-4227',
        address: '1250 South Service Rd - Unit D19',
        city: 'Mississauga',
        state: 'ON',
        postalCode: 'L5E 1V4',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 9:00 PM',
          tuesday: '10:00 AM - 9:00 PM',
          wednesday: '10:00 AM - 9:00 PM',
          thursday: '10:00 AM - 7:00 PM',
          friday: '11:00 AM - 6:00 PM',
          saturday: '10:00 AM - 9:00 PM',
          sunday: '10:00 AM - 9:00 PM'
        }
      }
    },
      {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-73.7569274, 45.5719995] },
      properties: {
        phoneFormatted: '(514) 428-1710',
        name: 'CF Carrefour Laval',
        address: '3035 Boul. le Carrefour',
        city: 'Laval',
        state: 'QC',
        postalCode: 'H7T 1C8',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 6:00 PM',
          tuesday: '10:00 AM - 6:00 PM',
          wednesday: '10:00 AM - 9:00 PM',
          thursday: '10:00 AM - 9:00 PM',
          friday: '10:00 AM - 9:00 PM',
          saturday: '09:00 AM - 7:00 PM',
          sunday: '10:00 AM - 6:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-73.8323681, 45.4641575] },
      properties: {
        phoneFormatted: '(514) 428-1710',
        name: 'CF Fairview Pointe Claire',
        phone: '(514) 428-1710',
        address: '6801 Trans-Canada Hwy',
        city: 'Pointe-Claire',
        state: 'QC',
        postalCode: 'H9R 4Y8',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 6:00 PM',
          tuesday: '10:00 AM - 6:00 PM',
          wednesday: '10:00 AM - 9:00 PM',
          thursday: '10:00 AM - 9:00 PM',
          friday: '10:00 AM - 9:00 PM',
          saturday: '9:00 AM - 5:00 PM',
          sunday: '10:00 AM - 5:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-73.6480484, 45.5281296] },
      properties: {
        phoneFormatted: '(514) 350-9523',
        name: 'Rockland Centre',
        phone: '(514) 350-9523',
        address: '2305 Rockland Rd',
        city: 'Montreal',
        state: 'QC',
        postalCode: 'H3P 3E9',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 6:00 PM',
          tuesday: '10:00 AM - 6:00 PM',
          wednesday: '10:00 AM - 6:00 PM',
          thursday: '10:00 AM - 9:00 PM',
          friday: '10:00 AM - 9:00 PM',
          saturday: '9:00 AM - 5:00 PM',
          sunday: '10:00 AM - 5:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-79.6895596, 43.4618365] },
      properties: {
        phoneFormatted: '(905) 337-5862',
        name: 'Oakville Place',
        phone: '(905) 337-5862',
        address: '240 Leighland Ave, Unit 241',
        city: 'Oakville',
        state: 'ON',
        postalCode: 'L6H 3H6',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 8:00 PM',
          tuesday: '10:00 AM - 8:00 PM',
          wednesday: '10:00 AM - 8:00 PM',
          thursday: '10:00 AM - 8:00 PM',
          friday: '10:00 AM - 8:00 PM',
          saturday: '10:00 AM - 6:00 PM',
          sunday: '11:00 AM - 5:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-79.5578605, 43.6304852] },
      properties: {
        phoneFormatted: '(416) 231-5551',
        name: 'Cloverdale Mall (Outlet)',
        phone: '(416) 231-5551',
        address: '250 The East Mall',
        city: 'Etobicoke',
        state: 'Ontario',
        postalCode: 'M9B 3Y8',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 8:00 PM',
          tuesday: '10:00 AM - 8:00 PM',
          wednesday: '10:00 AM - 8:00 PM',
          thursday: '10:00 AM - 8:00 PM',
          friday: '10:00 AM - 8:00 PM',
          saturday: '10:00 AM - 6:00 PM',
          sunday: '11:00 AM - 6:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-122.7884665, 49.0470089] },
      properties: {
        phoneFormatted: '(604) 538-2466',
        name: 'The Shops at Morgan Crossing',
        phone: '(604) 538-2466',
        address: '15715 Croydon Drive, Unit AB 108',
        city: 'Surrey',
        state: 'British Columbia',
        postalCode: 'V3S 2L5',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 6:00 PM',
          tuesday: '10:00 AM - 6:00 PM',
          wednesday: '10:00 AM - 6:00 PM',
          thursday: '10:00 AM - 6:00 PM',
          friday: '10:00 AM - 8:00 PM',
          saturday: '10:00 AM - 6:00 PM',
          sunday: '11:00 AM - 6:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-79.7924969, 43.3510158] },
      properties: {
        phoneFormatted: '(905) 319-2820',
        name: 'Burlington Centre',
        phone: '(905) 319-2820',
        address: '777 Guelph Line',
        city: 'Burlington',
        state: 'Ontario',
        postalCode: 'L7R 3N2',
        country: 'Canada',
        hours: {
          monday: '11:00 AM - 8:00 PM',
          tuesday: '11:00 AM - 8:00 PM',
          wednesday: '11:00 AM - 8:00 PM',
          thursday: '11:00 AM - 8:00 PM',
          friday: '11:00 AM - 8:00 PM',
          saturday: '9:30 AM - 8:00 PM',
          sunday: '11:00 AM - 6:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-123.36932993581841, 48.44672930476345] },
      properties: {
        phoneFormatted: '(250) 920-7902',
        name: 'Mayfair Shopping Centre',
        phone: '(250) 920-7902',
        address: '3147 Douglas Street Unit 359',
        city: 'Victoria',
        state: 'British Columbia',
        postalCode: 'V8Z 6E3',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 6:00 PM',
          tuesday: '10:00 AM - 6:00 PM',
          wednesday: '10:00 AM - 6:00 PM',
          thursday: '10:00 AM - 9:00 PM',
          friday: '10:00 AM - 9:00 PM',
          saturday: '10:00 AM - 6:00 PM',
          sunday: '10:00 AM - 5:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-79.3858314, 43.7678107] },
      properties: {
        phoneFormatted: '(416) 229-6474',
        name: 'Bayview Village',
        phone: '(416) 229-6474',
        address: '2901 Bayview Avenue, Unit 39',
        city: 'Toronto',
        state: 'Ontario',
        postalCode: 'M2K 1E6',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 8:00 PM',
          tuesday: '10:00 AM - 8:00 PM',
          wednesday: '10:00 AM - 8:00 PM',
          thursday: '10:00 AM - 8:00 PM',
          friday: '10:00 AM - 8:00 PM',
          saturday: '10:00 AM - 6:00 PM',
          sunday: '12:00 PM - 5:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-123.135832, 49.327522] },
      properties: {
        phoneFormatted: '(604) 922-2029',
        name: 'Park Royal Shopping Centre',
        phone: '(604) 922-2029',
        address: 'Unit # 964A, Park Royal S.C (south)',
        city: 'West Vancouver',
        state: 'British Columbia',
        postalCode: 'V7T 1A1',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 7:00 PM',
          tuesday: '10:00 AM - 7:00 PM',
          wednesday: '10:00 AM - 7:00 PM',
          thursday: '10:00 AM - 9:00 PM',
          friday: '10:00 AM - 9:00 PM',
          saturday: '10:00 AM - 8:00 PM',
          sunday: '10:00 AM - 6:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-71.279835, 46.77213] },
      properties: {
        phoneFormatted: '(418) 780-3038',
        name: 'Place Ste-Foy',
        phone: '(418) 780-3038',
        address: '2450 Blvd Laurier, Unit #127A',
        city: 'Quebec',
        state: 'Quebec',
        postalCode: 'G1V 2L1',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 6:00 PM',
          tuesday: '10:00 AM - 6:00 PM',
          wednesday: '10:00 AM - 6:00 PM',
          thursday: '10:00 AM - 9:00 PM',
          friday: '10:00 AM - 9:00 PM',
          saturday: '9:00 AM - 5:00 PM',
          sunday: '10:00 AM - 5:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-63.5811226, 44.6429513] },
      properties: {
        phoneFormatted: '(902) 423-0516',
        name: 'Park Lane Mall',
        phone: '(902) 423-0516',
        address: '5657 Spring Garden Road, Box 183',
        city: 'Halifax',
        state: 'Nova Scotia',
        postalCode: 'B3J 3R4',
        country: 'Canada',
        hours: {
          monday: '9:30 AM - 9:00 PM',
          tuesday: '9:30 AM - 9:00 PM',
          wednesday: '9:30 AM - 9:00 PM',
          thursday: '9:30 AM - 9:00 PM',
          friday: '9:30 AM - 9:00 PM',
          saturday: '9:30 AM - 9:00 PM',
          sunday: '12:00 PM - 5:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-81.277929, 43.026148] },
      properties: {
        phoneFormatted: '(519) 667-0096',
        name: 'Masonville Place',
        phone: '(519) 667-0096',
        address: '1680 Richmond St. N Unit U069',
        city: 'London',
        state: 'Ontario',
        postalCode: 'N6G 3Y9',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 9:00 PM',
          tuesday: '10:00 AM - 9:00 PM',
          wednesday: '10:00 AM - 9:00 PM',
          thursday: '10:00 AM - 9:00 PM',
          friday: '10:00 AM - 9:00 PM',
          saturday: '10:00 AM - 8:00 PM',
          sunday: '10:00 AM - 6:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-79.345007, 43.735518] },
      properties: {
        phoneFormatted: '(416) 384-0876',
        name: 'Shops at Don Mills',
        phone: '(416) 384-0876',
        address: '24 Karl Fraser Rd,  Unit J006B',
        city: 'Toronto',
        state: 'Ontario',
        postalCode: 'M3C 0G5',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 9:00 PM',
          tuesday: '10:00 AM - 9:00 PM',
          wednesday: '10:00 AM - 9:00 PM',
          thursday: '10:00 AM - 9:00 PM',
          friday: '10:00 AM - 9:00 PM',
          saturday: '10:00 AM - 7:00 PM',
          sunday: '11:00 AM - 6:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-79.452459, 43.80648] },
      properties: {
        phoneFormatted: '(905) 882-0121',
        name: 'Promenade',
        phone: '(905) 882-0121',
        address: '1 Promenade Circle, Unit #B208',
        city: 'Thornhill',
        state: 'Ontario',
        postalCode: 'L4J 4P8',
        country: 'Canada',
        hours: {
          monday: '10:00 AM - 8:00 PM',
          tuesday: '10:00 AM - 8:00 PM',
          wednesday: '10:00 AM - 8:00 PM',
          thursday: '10:00 AM - 8:00 PM',
          friday: '10:00 AM - 8:00 PM',
          saturday: '10:00 AM - 6:00 PM',
          sunday: '11:00 AM - 6:00 PM'
        }
      }
    },
    {
      type: 'Feature',
      geometry: { type: 'Point', coordinates: [-52.7568858, 47.5610105] },
      properties: {
        phoneFormatted: '(709) 722-7748',
        name: 'Avalon Mall',
        phone: '(709) 722-7748',
        address: '48 Kenmount Road, unit 2030',
        city: "St. John's",
        state: 'Newfoundland',
        postalCode: 'A1B 1W3',
        country: 'Canada',
        hours: {
          monday: '9:30 AM - 9:00 PM',
          tuesday: '9:30 AM - 9:00 PM',
          wednesday: '9:30 AM - 9:00 PM',
          thursday: '9:30 AM - 9:00 PM',
          friday: '9:30 AM - 9:00 PM',
          saturday: '9:30 AM - 9:00 PM',
          sunday: '12:00 PM - 5:00 PM'
        }
      }
    }
  ]
};

stores.features.forEach((store, i) => {
  store.properties.id = i;
});

const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/light-v11',
  center: [-79.5924498, 43.6184516],
  zoom: 4.5,
  scrollZoom: true
});

map.on('load', () => {
  map.addSource('places', {
    type: 'geojson',
    data: stores
  });

  const geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    mapboxgl: mapboxgl,
    marker: false,
    bbox: [-140.99778, 41.6751050889, -52.6480987209, 83.23324],
    placeholder: 'Search by city, postal code, or address'
  });

  buildLocationList(stores);
  map.addControl(geocoder, 'top-left');
  addMarkers();

  setTimeout(() => map.resize(), 200);
  setTimeout(() => map.resize(), 600);
  setTimeout(() => map.resize(), 1200);

  geocoder.on('result', (event) => {
    const searchResult = event.result.geometry;
    const options = { units: 'kilometers' };

    for (const store of stores.features) {
      store.properties.distance = turf.distance(searchResult, store.geometry, options);
    }

    stores.features.sort((a, b) => a.properties.distance - b.properties.distance);

    const listings = document.getElementById('listings');
    listings.innerHTML = '';
    buildLocationList(stores);

    createPopUp(stores.features[0]);

    const activeListing = document.getElementById(`listing-${stores.features[0].properties.id}`);
    if (activeListing) activeListing.classList.add('active');

    const bbox = getBbox(stores, 0, searchResult);
    map.fitBounds(bbox, { padding: 100 });
  });
});

window.addEventListener('load', () => {
  setTimeout(() => map.resize(), 500);
  setTimeout(() => map.resize(), 1000);
});

window.addEventListener('resize', () => {
  map.resize();
});

function getBbox(sortedStores, storeIdentifier, searchResult) {
  const lats = [
    sortedStores.features[storeIdentifier].geometry.coordinates[1],
    searchResult.coordinates[1]
  ];
  const lons = [
    sortedStores.features[storeIdentifier].geometry.coordinates[0],
    searchResult.coordinates[0]
  ];

  return [
    [Math.min(...lons), Math.min(...lats)],
    [Math.max(...lons), Math.max(...lats)]
  ];
}

function addMarkers() {
  for (const marker of stores.features) {
    const el = document.createElement('div');
    el.id = `marker-${marker.properties.id}`;
    el.className = 'marker';

    new mapboxgl.Marker(el, { offset: [0, -23] })
      .setLngLat(marker.geometry.coordinates)
      .addTo(map);

    el.addEventListener('click', (e) => {
      e.stopPropagation();
      flyToStore(marker);
      createPopUp(marker);

      const activeItem = document.getElementsByClassName('active');
      if (activeItem[0]) {
        activeItem[0].classList.remove('active');
      }

      const listing = document.getElementById(`listing-${marker.properties.id}`);
      if (listing) listing.classList.add('active');
    });
  }
}

function buildLocationList(storesData) {
  const listings = document.getElementById('listings');

  for (const store of storesData.features) {
    const listing = listings.appendChild(document.createElement('div'));
    listing.id = `listing-${store.properties.id}`;
    listing.className = 'item';

    const link = listing.appendChild(document.createElement('a'));
    link.href = '#';
    link.className = 'title';
    link.id = `link-${store.properties.id}`;
    link.innerHTML = `${store.properties.name}`;

    const details = listing.appendChild(document.createElement('div'));
    details.className = 'listing-details';

    let html = `
      ${store.properties.address}<br/>
      ${store.properties.city}, ${store.properties.state} ${store.properties.postalCode}<br/>
    `;

    if (store.properties.phone) {
      html += `<strong>Phone:</strong> <a href="tel:${sanitizePhone(store.properties.phoneFormatted)}">${store.properties.phoneFormatted}</a><br/>`;
    }

    html += renderHoursBlock(store.properties);

    if (store.properties.distance !== undefined) {
      const roundedDistance = Math.round(store.properties.distance * 10) / 10;
      html += `<div><strong>${roundedDistance} km away</strong></div>`;
    }

    details.innerHTML = html;

    link.addEventListener('click', function (e) {
      e.preventDefault();

      for (const feature of storesData.features) {
        if (this.id === `link-${feature.properties.id}`) {
          flyToStore(feature);
          createPopUp(feature);
        }
      }

      const activeItem = document.getElementsByClassName('active');
      if (activeItem[0]) {
        activeItem[0].classList.remove('active');
      }

      this.parentNode.classList.add('active');
    });
  }

  bindHoursToggles();
}

function flyToStore(currentFeature) {
  map.flyTo({
    center: currentFeature.geometry.coordinates,
    zoom: 15
  });
}

function createPopUp(currentFeature) {
  const popUps = document.getElementsByClassName('mapboxgl-popup');
  if (popUps[0]) popUps[0].remove();

  const popupPhone = currentFeature.properties.phone
    ? `<br/><strong>Phone:</strong> <a href="tel:${sanitizePhone(currentFeature.properties.phoneFormatted)}">${currentFeature.properties.phoneFormatted}</a>`
    : '';

  new mapboxgl.Popup({ closeOnClick: true })
    .setLngLat(currentFeature.geometry.coordinates)
    .setHTML(`
      <div class="mapbox-popup">
        <h3>${currentFeature.properties.name}</h3>
        <p>
          ${currentFeature.properties.address}<br/>
          ${currentFeature.properties.city}, ${currentFeature.properties.state} ${currentFeature.properties.postalCode}
          ${popupPhone}
        </p>
        <div class="popup-hours">
          ${renderTodayHours(currentFeature.properties)}
        </div>
      </div>
    `)
    .addTo(map);
}

function sanitizePhone(phone) {
  return (phone || '').replace(/[^\d+]/g, '');
}

function getTodayKey() {
  const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  return days[new Date().getDay()];
}

function formatDayLabel(day) {
  return day.charAt(0).toUpperCase() + day.slice(1);
}

function renderTodayHours(properties) {
  if (!properties.hours) return '';
  const today = getTodayKey();
  const todayHours = properties.hours[today] || 'Hours unavailable';
  return `<strong>Today:</strong> ${todayHours}`;
}

function renderHoursBlock(properties) {
  if (!properties.hours) return '';

  const today = getTodayKey();
  const daysOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  const weeklyRows = daysOrder.map((day) => {
    return `
      <div class="store-hours__row">
        <span>${formatDayLabel(day)}</span>
        <span>${properties.hours[day] || 'Closed'}</span>
      </div>
    `;
  }).join('');

  const weeklyId = `hours-weekly-${properties.id}`;

  return `
    <div class="store-hours">
      <div class="store-hours__today">
        <strong>Today:</strong> ${properties.hours[today] || 'Hours unavailable'}
      </div>
      <button type="button" class="store-hours__toggle" data-target="${weeklyId}">
        View hours of operation
      </button>
      <div class="store-hours__weekly" id="${weeklyId}" style="display:none;">
        ${weeklyRows}
      </div>
    </div>
  `;
}

function bindHoursToggles() {
  const toggles = document.querySelectorAll('.store-hours__toggle');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const targetId = toggle.getAttribute('data-target');
      const target = document.getElementById(targetId);

      if (!target) return;

      const isOpen = target.style.display === 'block';
      target.style.display = isOpen ? 'none' : 'block';
      toggle.textContent = isOpen ? 'View hours of operation' : 'Hide hours of operation';
    });
  });
}